// extracted by mini-css-extract-plugin
module.exports = {"title":"FinancialSavings_title__2-lCz","icon":"FinancialSavings_icon__1aw7P"};